import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess'
import { useBreadcrumbs } from 'global/cnr/contexts/useHelpers/useBreadcrumbs'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import { SportsDistrictContext } from 'projectSpecific/sports/cnr/contexts/SportsDistrictContext'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import { useMatchUpdate } from 'projectSpecific/sports/useHelpers/useMatchUpdate'
import { useContext, useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Icon, Label } from 'semantic-ui-react'
import SportsAthletes from '../athletes/SportsAthletes'
import { _sdm } from '../dashboard/SportsDashboard'
import SportsSeasons from '../seasons/SportsSeasons'
import MatchResults from '../matches/MatchResults'
import { GroupSquares } from 'global/wrappers/GroupSquares'
import UiSaveButtons from 'global/components/buttons/UiSaveButtons'
import { useRealtimeUpdate } from 'projectSpecific/sports/useHelpers/useRealtimeUpdate'
import { _realtimeMatchTypes } from 'projectSpecific/sports/useHelpers/useRealtimeResults'
import { _allowSportsUpdates } from 'projectSpecific/sports/useHelpers/useSeasonals'
import { openExternal } from 'global/viewSettings/helpers/settingsLinks'
import { useSportsMatches } from 'projectSpecific/sports/useHelpers/useSportsMatches'
import MatchLookup from '../matches/MatchLookup'
import { _msTypes } from '../matches/MatchSquares'
import { MatchPendings } from '../matches/MatchPendings'

const _sportsInfoItems = {
  options: 'options',
  results: 'results',
  pendingPlayoffMatches: 'pendingPlayoffMatches',
  pastSeasons: 'pastSeasons',
  teamRosters: 'teamRosters',
  teams: 'teams',
  commitGsResults: 'commitGsResults',
  commitMatchDayResults: 'commitMatchDayResults',
  appUserCount: 'appUserCount',
  openGS: 'openGs',
  missingResults: 'missingResults',
  matchLookup: 'matchLookup',
}

export const _resultModes = {
  ammend: 'ammend',
  backup: 'backup',
  export: 'export',
  media: 'media',
  openExternal: 'openExternal',
  scores: 'scores',
  search: 'search',
}

export const SportInfoSquares = ({ menuItems }) => {

  const location = useLocation()
  const navigate = useNavigate();

  const { getMatches_missing } = useSportsMatches()
  const { updateMatchResults_fromRealtime, updating } = useMatchUpdate()
  const { deleteMatch_realtime } = useRealtimeUpdate()

  const appUserAccess = useAppUserAccess()
  const { isAdminOrSuper } = appUserAccess ?? {}

  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { dailyCounts, dailyCountsU, currentUserCount, lastItemCount } = sportsDistrict_state ?? {}

  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state } = sportsSeasonContext ?? {};
  const { matchDayResults, gsResults, teams_info, matches_info, sportPermissions, links_score } = sportsSeason_state ?? {};
  const { matches, matchPlayoffPendings } = matches_info ?? {};
  const { teams } = teams_info ?? {};
  const { googleSheetsId } = links_score ?? {};

  const allowUpdate = sportPermissions?.any && _allowSportsUpdates.matches

  // const matches_matchDayResultsXX = useMemo(() => {
  //   const ms = {}
  //   _.forEach(matchDayResults, (mdr, matchKey) => {
  //     if (matches?.[matchKey]) {
  //       ms[matchKey] = matches[matchKey]
  //     }
  //   })
  //   return ms
  // }, [matchDayResults, matches])

  const matches_matchDayResults = useMemo(() => {
    const ms = {}
    _.forEach(matchDayResults, (mdr, matchKey) => {
      if (matches?.[matchKey]) {
        const _mdr = _.head(_.values(mdr))
        ms[matchKey] = {
          ...matches[matchKey],
          results: _mdr?.results
        }
      }
    })
    return ms
  }, [matchDayResults, matches])

  const matches_gsResults = useMemo(() => {
    const ms = {}
    _.forEach(gsResults, (mdr, matchKey) => {
      if (matches?.[matchKey]) {
        const _mdr = _.head(_.values(mdr))
        ms[matchKey] = {
          ...matches[matchKey],
          results: _mdr?.results
        }
      }
    })
    return ms
  }, [gsResults, matches])

  const matches_missing = useMemo(() => {
    return getMatches_missing({ matches_info })
  }, [matchDayResults, matches])

  const [selectedSportItem, setSelectedSportItem] = useState()

  const sportInfoItems = useMemo(() => {
    if (!isAdminOrSuper) {
      return _.omit(_sportsInfoItems, [
        _sportsInfoItems.appUserCount,
        _sportsInfoItems.results,
        _sportsInfoItems.commitGsResults,
        _sportsInfoItems.commitMatchDayResults,
        _sportsInfoItems.openGS,
        _sportsInfoItems.missingResults,
        _sportsInfoItems.pendingPlayoffMatches,
      ])
    }
    return _sportsInfoItems
  }, [isAdminOrSuper])


  const oc_team = (item) => {
    navigate(`${location.pathname}/teams/${item?._itemKey}`)
  }

  const oc_update_matchDayResults = () => {
    const cb = () => {
      console.log('cb')
    }
    updateMatchResults_fromRealtime({ results_realtime: matchDayResults, callback: cb })
  }

  const oc_update_gsResults = () => {
    const cb = () => {
      console.log('cb')
      if (allowUpdate) {
        oc_clear_gsResults()
      }
    }
    updateMatchResults_fromRealtime({ results_realtime: gsResults, callback: cb })
  }

  const oc_clear_matchDayResults = () => {
    deleteMatch_realtime({ match_rt: null, removeAll: true, realtimeMatchType: _realtimeMatchTypes.matchDayResults })
  }

  const oc_clear_gsResults = () => {
    deleteMatch_realtime({ match_rt: null, removeAll: true, realtimeMatchType: _realtimeMatchTypes.gsResults })
  }

  const fnIcon = (item) => {
    switch (item) {
      case _sportsInfoItems.pastSeasons:
        return 'calendar outline'

      case _sportsInfoItems.teams:
      case _sportsInfoItems.teamRosters:
        return 'users'

      case _sportsInfoItems.results:
        return 'trophy'

      case _sportsInfoItems.appUserCount:
        return 'hashtag'

      case _sportsInfoItems.updateResults:
      case _sportsInfoItems.commitMatchDayResults:
      case _sportsInfoItems.commitGsResults:
      case _sportsInfoItems.pendingPlayoffMatches:
        return 'edit'

      case _sportsInfoItems.openGS:
        return 'external alternate'
      // case _sportsInfoItems.favorites:
      //   return 'heart'
    }
    return 'cog'
  }

  const fnAlt = (item) => {
    switch (item) {
      case _sportsInfoItems.commitGsResults:
        return <Label size='mini' color={!_.isEmpty(gsResults) ? 'blue' : 'grey'}>{_.size(gsResults)}</Label>
      case _sportsInfoItems.commitMatchDayResults:
        return <Label size='mini' color={!_.isEmpty(matchDayResults) ? 'blue' : 'grey'}>{_.size(matchDayResults)}</Label>
      case _sportsInfoItems.appUserCount:
        return <Label size='mini' color='blue'>{`${dailyCounts?.todaysCount?.count}/${lastItemCount}/${currentUserCount}`}</Label>
      case _sportsInfoItems.openGS:
        return <Icon name='external alternate' color='orange' />
      case _sportsInfoItems.missingResults:
        return <Label size='mini' color={!_.isEmpty(matches_missing) ? 'blue' : 'grey'}>{_.size(matches_missing)}</Label>
      case _sportsInfoItems.pendingPlayoffMatches:
        return <Label size='mini' color={!_.isEmpty(matchPlayoffPendings) ? 'blue' : 'grey'}>{_.size(matchPlayoffPendings)}</Label>
      default:
        return <Icon name='list' color='blue' />
    }
  }

  const imsAlt = (item) => {
    const { results } = item ?? {}
    const { score } = results ?? {}
    return `${score?.away} - ${score?.home}`
  }

  const fnContentCurrentGroup = (cg) => {
    // if (allGroups) {
    const _currentGroup = cg //|| currentGroup
    const { key, menuItems, value } = _currentGroup ?? {}
    switch (key) {
      case _sportsInfoItems.commitMatchDayResults:
        const _allowMdr = !_.isEmpty(matches_matchDayResults)
        console.log('matches_matchDayResults', matches_matchDayResults)
        return <Wrapper
          header={'Confirmation'}
          content={_allowMdr ? <ItemMenuSquares menuItems={matches_matchDayResults} fn_altContent={imsAlt} /> : 'No Match Day Matches to update'}
          footer={_allowMdr &&
            <UiSaveButtons
              save={{ oc: oc_update_matchDayResults, caption: 'Confirm', color: allowUpdate ? 'green' : 'teal' }}
              cancel={{ oc: oc_clear_matchDayResults, caption: 'Clear', icon: 'arrow right', fl: true }}
            />}
          // <UiSaveButtons
          //   save={{
          //     oc: oc_update_matchDayResults,
          //     caption: 'Confirm',
          //     color: allowUpdate ? 'green' : 'teal'
          //   }} />}
          // cancel={{
          //   oc: oc_clear_matchDayResults,
          //   caption: 'Clear',
          //   icon: 'arrow right',
          //   fl: true
          // }}
          wrapperType={wrapperTypes.padded}
          updating={updating}
        ></Wrapper>

      case _sportsInfoItems.commitGsResults:
        console.log('gsResults', gsResults)
        const _allowGs = !_.isEmpty(matches_gsResults)
        return <Wrapper
          header={'Confirmation'}
          content={_allowGs ? <ItemMenuSquares menuItems={matches_gsResults} imsType={_imsTypes.match} fn_altContent={imsAlt} /> : 'No GS Matches to update'}
          footer={_allowGs && <UiSaveButtons
            save={{ oc: oc_update_gsResults, caption: 'Confirm', color: allowUpdate ? 'green' : 'teal' }}
            preview={{ oc: oc_clear_gsResults, caption: 'Clear', icon: 'arrow right', fl: true }}
          />}
          wrapperType={wrapperTypes.padded}
          updating={updating}
        ></Wrapper>

      case _sportsInfoItems.pastSeasons:
        return <SportsSeasons handleCancel={setSelectedSportItem} noFull={true} />

      case _sportsInfoItems.teamRosters:
        return <SportsAthletes sportsDisplayType={selectedSportItem} handleCancel={setSelectedSportItem} />

      case _sportsInfoItems.pendingPlayoffMatches:
        return <MatchPendings />

      case _sportsInfoItems.results:
        return <MatchResults
          fromApp={true}
          forSportsManagement={true}
          sportsDataMode={_sdm.sports.seasonResults}
          handleCancel={setSelectedSportItem}
          noFull={true}
        />
      case _sportsInfoItems.appUserCount:
        return <div>appUserCount</div>

      case _sportsInfoItems.teams:
        return <ItemMenuSquares
          imsType={_imsTypes.normal}
          menuItems={_.sortBy(teams, 'name')}
          iconItem={'users'}
          onClick={oc_team}
        />

      case _sportsInfoItems.missingResults:
        const oc = () => {
          openExternal.googleSheets(googleSheetsId)
        }
        return <ItemMenuSquares
          imsType={_imsTypes.match}
          menuItems={matches_missing}
          fn_altContent={fnAlt}
          onClick={oc}
        />

      case _sportsInfoItems.matchLookup:
        return <MatchLookup msType={_msTypes.teams} />

      case _sportsInfoItems.openGS:
        if (googleSheetsId) {
          openExternal.googleSheets(googleSheetsId)
        }
        return <div>GS</div>
    }
  }

  return <GroupSquares
    menuItems={sportInfoItems}
    fnCurrentGroup={fnContentCurrentGroup}
    fnAlt={fnAlt}
    fnIcon={fnIcon}
    caption={'Sports Options'}
  />

}
